var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83908 7.41046H14.8567C18.5058 7.41046 21.4639 10.3686 21.4639 14.0176V14.1419C21.4639 17.7909 18.5058 20.749 14.8567 20.749H8.42817C7.93506 20.749 7.53531 20.3493 7.53531 19.8562C7.53531 19.363 7.93506 18.9633 8.42817 18.9633H14.8567C17.5195 18.9633 19.6782 16.8047 19.6782 14.1419V14.0176C19.6782 11.3548 17.5195 9.19618 14.8567 9.19618H4.83933C5.55534 10.3425 6.64054 11.143 8.13766 11.6101C8.60838 11.757 8.87093 12.2576 8.72406 12.7284C8.57718 13.1991 8.07653 13.4616 7.6058 13.3148C5.13297 12.5432 3.42751 10.9631 2.5869 8.60268C2.51791 8.40893 2.51791 8.19732 2.5869 8.00359C3.42751 5.64318 5.13297 4.06302 7.6058 3.29149C8.07653 3.14462 8.57718 3.40717 8.72406 3.87791C8.87093 4.34863 8.60838 4.84929 8.13766 4.99616C6.64037 5.46332 5.5551 6.26393 4.83908 7.41046Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/Undo.8c27eeb5.svg";
export { ForwardRef as ReactComponent };